<div class="_form_credit_card">
  <form [formGroup]="form">
    <mat-form-field appearance="outline"
    [ngClass]="{ 'disabledInput': isControlReadOnly('cellPhone') }">
      <mat-label>Móvil</mat-label>
      <input
        autocomplete="off"
        type="text"
        matInput
        placeholder="Móvil"
        required
        name="cellPhone"
        formControlName="cellPhone"
        readonly="{{ isControlReadOnly('cellPhone') }}"
      />
      <fa-icon matSuffix icon="mobile-alt"></fa-icon>
    </mat-form-field>
    <ng-container *ngFor="let validation of errorsMessages.cellPhone">
      <div class="error-message" *ngIf="form.get('cellPhone').hasError(validation.type) && (form.get('cellPhone').dirty || form.get('cellPhone').touched)">
        {{ validation.message }}
      </div>
    </ng-container>
    <mat-form-field appearance="outline" [ngClass]="{ disabledInput: isControlReadOnly('email') }">
      <mat-label>Correo electrónico</mat-label>
      <input
        autocomplete="off"
        type="text"
        matInput
        placeholder="Email"
        required
        name="email"
        formControlName="email"
        readonly="{{ isControlReadOnly('email') }}"
      />
      <fa-icon matSuffix icon="envelope"></fa-icon>
    </mat-form-field>
    <ng-container *ngFor="let validation of errorsMessages.email">
      <div class="error-message" *ngIf="form.get('email').hasError(validation.type) && (form.get('email').dirty || form.get('email').touched)">
        {{ validation.message }}
      </div>
    </ng-container>
  </form>
</div>
